<template>
	<div class="employerProfile">
		<!-- Main Body Content area -->
        <div v-loading="loading" class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
              <div class="col-md-5">
                <p class="u-back"><a href="javascript: void(0)" @click="$router.go(-1)"><i class="fa fa-chevron-left"></i> Back</a></p>
              </div>
              <div class="col-md-7 text-right">
                <ul class="o-filter-area">
                  <li><a href="javascript: void(0)" @click="editProfile()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</a></li>
                </ul>
              </div>
              <div class="col-md-12 c-user">
                <div class="c-user__profile-pic u-mar-right-10">
                  <img v-if="detailEmployer && (detailEmployer.user.image!=''||detailEmployer.user.image!=null)" :src="detailEmployer.user.image" />
                  <img  v-if="(detailEmployer && (detailEmployer.user.image==''||detailEmployer.user.image==null))|| !detailEmployer" src="static/assets/images/user1.png" />
                </div>
                <div class="c-user__profile-details">
                  <h4 class="h1">{{detailEmployer && detailEmployer.user ? detailEmployer.user.first_name : ''}}</h4>
                  <p>Email ID: {{detailEmployer && detailEmployer.user ? detailEmployer.user.email : ''}}</p>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- /Heading Section -->
            <!-- Main Body Content area -->
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Personal Details:</h3> 
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Nickname</h5>
                            <p>
                              {{detailEmployer && detailEmployer.user ? detailEmployer.user.display_name : ''}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Secondary Email</h5>
                            <p>
                              {{detailEmployer && detailEmployer.user ? detailEmployer.user.secondary_email : ''}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Date of Birth</h5>
                            <p>
                              {{detailEmployer && detailEmployer.user && detailEmployer.user.dob ? detailEmployer.user.dob : ''}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Client Access</h5>
                            <p>
                              <span v-for="client in associateClientList" v-if="client.status_id!=null">{{client.client.subdomain}}</span>
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div v-if="!loading" class="clearfix o-employer-a">
                      <h3>Phone & Fax:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Primary Phone No.</h5>
                            <p v-for="phone in detailEmployer.user.phones" v-if="phone.label=='Primary phone'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Secondary Phone No.</h5>
                            <p v-for="phone in detailEmployer.user.phones" v-if="phone.label=='Secondary phone'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Cell Phone</h5>
                            <p v-for="phone in detailEmployer.user.phones" v-if="phone.label=='Cell phone'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Fax</h5>
                            <p v-for="phone in detailEmployer.user.phones" v-if="phone.label=='Fax'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div v-if="!loading" class="clearfix o-employer-a">
                      <h3>Address:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Street</h5>
                            <p v-if="detailEmployer.user.addresses && detailEmployer.user.addresses.length>0">
                              {{detailEmployer.user.addresses[0].address}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>City</h5>
                            <p v-if="detailEmployer.user.addresses && detailEmployer.user.addresses.length>0">
                              {{detailEmployer.user.addresses[0].municipality}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>State</h5>
                            <p v-if="detailEmployer.user.addresses && detailEmployer.user.addresses.length>0">
                              {{detailEmployer.user.addresses[0].state_province}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Zip</h5>
                            <p v-if="detailEmployer.user.addresses && detailEmployer.user.addresses.length>0">
                              {{detailEmployer.user.addresses[0].postcode}}
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- /Main Body Content area -->
    </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters, mapActions } from 'vuex';
    import service from '../../services.js';
    import { global } from '../../global.js';

    export default {
        data() {
            return {
                detailEmployer:null,
                loading:true,
                associateClientList:null,
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole:'userRole',
                userID: 'userID',
                companyId: 'companyId',
                employerUserId : 'employerUserId',
            })
        },
        methods: {
            getEmployerClient(){
              service.get('employer/'+this.companyId+'/getEmployerClientAssociation', {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
              })
              .then((res) => {
                  this.associateClientList = res.data.result;
                  //console.log(this.associateClientList);
              }).catch((err) => {
                  console.log(err);
              });
            },
            editProfile(){
              this.$router.push({
                path: `/editEmployerUser/`+this.$route.params.id
              });
            },
            getDate(str) {
                return dateTimeConvert.globalDate(str);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            empDetails() {
                this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                this.loading=true;
                //console.log('this.employerUserId',this.employerUserId);
                service.get('employer/'+ atob(this.$route.params.id)+'/getEmployerProfile', {
                    'Authorization': this.userToken,
                }).
                then((res) => {
                    this.$Progress.finish();
                    this.detailEmployer = res.data.result;
                    this.loading=false;

                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
            backToEmployerList() {
                this.$router.push({
                    path: `/clientEmployersList`
                });
            },
            
            // phoneNumberCheck(phone_number, type) {
            //     let self = this;
            //     let primaryPhone = "";
            //     if (phone_number) {
            //         phone_number.forEach(function(employerphone) {
            //             if (employerphone.label == type) {
            //                 //console.log(employerphone.label);
            //                 primaryPhone = employerphone.phone_number;
            //             }
            //         });
            //     }
            //     return primaryPhone;

            // },

        },
        created() {
            this.empDetails();
            this.getEmployerClient();
            //console.log(atob(this.$route.params.id));

        }
    }

</script>


// WEBPACK FOOTER //
// src/components/employers/empoyerProfile.vue